import React from 'react';
import { BookingDetails } from "@/hooks/bookings/types";
import ActivityTimeline from "./ActivityTimeline";
interface ActivityTabProps {
  booking: BookingDetails;
}
const ActivityTab: React.FC<ActivityTabProps> = ({
  booking
}) => {
  return <div className="space-y-6 px-[5px] py-[5px]">
      <ActivityTimeline bookingId={booking.id} />
    </div>;
};
export default ActivityTab;